<div>
  <h2 mat-dialog-title>Create a New Campus</h2>
  <mat-progress-bar *ngIf="loading"></mat-progress-bar>
  <mat-dialog-content>
    <p>Enter the campus information below to create a new college.</p>

    <form [formGroup]="newCampusForm" class="flex flex-col">
      <mat-form-field>
        <mat-label> College </mat-label>
        <mat-select formControlName="collegeId">
          @for (college of colleges; track college.id) {
          <mat-option [value]="college.id">{{ college.name }}</mat-option>
          }
        </mat-select>
        <mat-error *ngIf="this.newCampusForm.controls.collegeId.invalid">
          College is required.
        </mat-error>
      </mat-form-field>

      <mat-form-field>
        <mat-label> Name</mat-label>
        <input matInput type="text" formControlName="name" maxlength="" />
        <mat-error *ngIf="this.newCampusForm.controls.name.invalid">
          Campus name is required.
        </mat-error>
      </mat-form-field>

      <mat-form-field>
        <mat-label> Email Domain </mat-label>
        <input
          matInput
          type="text"
          formControlName="emailDomain"
          placeholder="abu.edu"
          maxlength=""
        />
        <mat-error *ngIf="this.newCampusForm.controls.emailDomain.invalid">
          Email domain is required.
        </mat-error>
      </mat-form-field>

      <mat-form-field>
        <mat-label> Street </mat-label>
        <input matInput type="text" formControlName="street" maxlength="" />
        <mat-error *ngIf="this.newCampusForm.controls.street.invalid">
          Street is required.
        </mat-error>
      </mat-form-field>

      <div class="flex flex-col md:flex-row gap-2 w-full">
        <mat-form-field>
          <mat-label> City </mat-label>
          <input matInput type="text" formControlName="city" maxlength="" />
          <mat-error *ngIf="this.newCampusForm.controls.city.invalid">
            City is required.
          </mat-error>
        </mat-form-field>

        <mat-form-field>
          <mat-label> State </mat-label>
          <mat-select formControlName="state">
            @for (state of states; track state) {
            <mat-option [value]="state">{{ state }}</mat-option>
            }
          </mat-select>
          <mat-error *ngIf="this.newCampusForm.controls.state.invalid">
            State is required.
          </mat-error>
        </mat-form-field>

        <mat-form-field>
          <mat-label> Zipcode </mat-label>
          <input matInput type="text" formControlName="zipcode" maxlength="5" />
          <mat-error *ngIf="this.newCampusForm.controls.zipcode.invalid">
            Zipcode is required.
          </mat-error>
        </mat-form-field>
      </div>
    </form>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button (click)="onCancel()">Cancel</button>
    <button
      mat-raised-button
      [disabled]="newCampusForm.invalid"
      color="accent"
      (click)="submit()"
    >
      Submit
    </button>
  </mat-dialog-actions>
</div>
